import React, { useContext, useEffect, useState } from 'react'
import { getImages } from '../Const'
import { UserContext } from '../Context/UserContext'
import { Link, NavLink, useLocation } from 'react-router-dom';
import { LeadsContext } from '../Context/LeadsContext';
import { useTheme } from '../Context/ThemeContext';
import CustomDropdown from './CustomDropdown';

const Header = () => {

    const { user, logout, logActivity } = useContext(UserContext);

    const { notifications, selectLead, setActiveLeadAction } = useContext(LeadsContext);
    const [isMob, setisMob] = useState(false);
    const onChangeBodyClass = (value) => {
        setisMob(value);
        value
            ? document.body.classList.add('overflow-active')
            : document.body.classList.remove('overflow-active');
    };


    const location = useLocation();
    const customerQueueRoutes = ["/store", "/edit-announcements", "/search", "/auto-emailer"];
    const headerClass = customerQueueRoutes.some(route => location.pathname.includes(route))
        ? "header-wrap customer-queue-header"
        : "header-wrap";

    const now = new Date();

    const chatTimeSince = (date) => {

        var seconds = Math.floor((now - date * 1000) / 1000);

        var interval = Math.floor(seconds / 31536000);

        if (interval > 1) {
            return interval + " years";
        }
        interval = Math.floor(seconds / 2592000);
        if (interval > 1) {
            return interval + " months";
        }
        interval = Math.floor(seconds / 86400);
        if (interval > 1) {
            return interval + " days";
        }
        interval = Math.floor(seconds / 3600);
        if (interval > 1) {
            return interval + " hours";
        }
        interval = Math.floor(seconds / 60);
        if (interval > 1) {
            return interval + " minutes";
        }
        return Math.floor(seconds) + " seconds";
    }

    const [unreadSms, setUnreadSMS] = useState(0);
    const [unreadEmail, setUnreadEmail] = useState(0);

    const [smsNofications, setSmsNotifications] = useState([]);
    const [emailNotifications, setEmailNotifications] = useState([]);

    const inStore = window.location.pathname.includes('/store');

    useEffect(() => {
        // console.log("notificaions update");
        if (notifications) {
            const use_notifications = inStore ? notifications.filter((note) => !note.web) : notifications.filter((note) => note.web);
            setUnreadSMS(use_notifications.filter((note) => note.title == "Received SMS" && note.unread).length);
            setUnreadEmail(use_notifications.filter((note) => note.title == "Received Email" && note.unread).length);
            setSmsNotifications(use_notifications.filter((note) => note.title == "Received SMS"));
            setEmailNotifications(use_notifications.filter((note) => note.title == "Received Email"));
        }
    }, [notifications]);

    useEffect(() => {
        document.title = "Car Drop" + (unreadSms + unreadEmail > 0 ? (" (" + (unreadSms + unreadEmail) + ")") : "");
    }, [unreadSms, unreadEmail])

    const { theme, toggleTheme } = useTheme();
    const isAdmin = user?.admin === 1;

    useEffect(() => {
        const handleUnload = () => {
          // Perform cleanup or send data using methods like sendBeacon
          // which are designed for reliable data transmission during unload.

        //   console.log("visibilitychange, sending beacon");

          navigator.sendBeacon('https://cardropcrm.com/bridge/user/logActivity.php', JSON.stringify({'username':user.username,'field':'last_login'}));
          //logActivity();
        };
    
        window.addEventListener('visibilitychange', handleUnload);

        //console.log("sending beacon",JSON.stringify({'username':user.username,'field':'last_login'}));
        //navigator.sendBeacon('https://cardropcrm.com/bridge/user/logActivity.php', JSON.stringify({'username':user.username,'field':'last_login'}));
    
        return () => {
          window.removeEventListener('visibilitychange', handleUnload);
        };
    }, []);

    return (
        <>
            {/* {console.log("theme", theme)} */}
            <header className={headerClass}>
                <div className="container-fluid">
                    <div className="header-block d-flex align-items-center">
                        <div className="header-left">
                            <Link to="/web" className="main-logo">
                                <img src={getImages('main-logo.png')} alt='logo' />
                            </Link>
                        </div>
                        <div className="header-right d-flex align-items-center justify-content-between menu-block">
                            <div className={`d-flex w-100 align-items-center justify-content-between menus-for-mobile ${isMob ? 'active' : ''}`}>
                                <div className="main-menu">
                                    <ul>
                                        <li>
                                            <NavLink to="/store">In-Store</NavLink>
                                        </li>
                                        {isAdmin && 
                                            <>
                                                <li>
                                                    <NavLink to="/web">Web Leads</NavLink>
                                                </li> 
                                                <li>
                                                    <NavLink to="/edit-announcements">Announcements</NavLink>
                                                </li> 
                                                {/* <li>
                                                    <NavLink to="/auto-emailer">Auto Emailer</NavLink>
                                                </li>  */}
                                            </> 
                                        }
                                    </ul>
                                </div>
                                <div className="login-block d-flex">
                                    <div className="dropdown header-icon-btn me-3">
                                        <button className="btn btn-light position-relative" type="button" data-bs-toggle="dropdown" aria-expanded="false" onClick={() => { setUnreadSMS(0); logActivity('last_read_sms'); }}>
                                            <img src={getImages('chat-material.png')} />
                                            <span className="position-absolute start-75 translate-middle badge rounded-pill bg-danger">
                                                {unreadSms > 0 ? unreadSms : ""}
                                            </span>
                                        </button>
                                        <ul className={`dropdown-menu dropdown-menu-end ${smsNofications.length > 5 ? 'overflow-scroll-max-height' : ''}`}>
                                            {notifications && smsNofications.map((item, index) => (
                                                <li key={index} className="d-flex justify-content-between" onClick={() => { selectLead(item.lead_id,"text"); setActiveLeadAction("text"); }}>
                                                    <div>
                                                        <div className={"hib-title1 " + (item.location == "POMPANO BEACH" ? "text-green" : "")}>{item.full_name}{item.responded ? "" : <span>&#128308;</span>}</div>
                                                        <div className="hib-title2">{item.vehicle_name}</div>
                                                        <p className="two-line-ellipsis">{item.note}</p>
                                                    </div>
                                                    <div className="ps-3">
                                                        <p>{chatTimeSince(item.timestamp)} ago</p>
                                                        {item.hasDot && <div className="circle-dot"></div>}
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="dropdown header-icon-btn">
                                        <button className="btn btn-light position-relative" type="button" data-bs-toggle="dropdown" aria-expanded="false" onClick={() => { setUnreadEmail(0); logActivity('last_read_email'); }}>
                                            <img src={getImages('header_email_icon.png')} />
                                            <span className="position-absolute start-75 translate-middle badge rounded-pill bg-danger">
                                                {unreadEmail > 0 ? unreadEmail : ""}
                                            </span>
                                        </button>
                                        <ul className={`dropdown-menu dropdown-menu-end ${emailNotifications.length > 5 ? 'overflow-scroll-max-height' : ''}`} >
                                            {notifications && emailNotifications.map((item, index) => (
                                                <li key={index} className="d-flex justify-content-between" onClick={() => { selectLead(item.lead_id,"email"); setActiveLeadAction("email"); }}>
                                                    <div>
                                                        <div className="hib-title1">{item.full_name}{item.responded ? "" : <span>&#128308;</span>}</div>
                                                        <div className="hib-title2">{item.vehicle_name}</div>
                                                        <p className="two-line-ellipsis">{item.note}</p>
                                                    </div>
                                                    <div className="ps-3">
                                                        <p>{chatTimeSince(item.timestamp)} ago</p>
                                                        {item.hasDot && <div className="circle-dot"></div>}
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    {/* <div className="btn-group custom-dropdown header-custom-dropdown ms-3">
                                        <button type="button" className="btn btn-secondary dropdown-toggle text-green" data-bs-toggle="dropdown" aria-expanded="false">
                                            <img src={getImages('user-icon.svg')} /> Welcome {user && user.first_name}
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-end">
                                            <button className="dropdown-item text-uppercase text-dblue" type="button" onClick={() => logout()}>Logout</button>
                                            <div className="dropdown-item">
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div className='text-capitalize'>{theme} Theme</div>
                                                    <div>
                                                        <label className="switch">
                                                            <input type="checkbox" checked={theme === 'light'} onChange={toggleTheme} />
                                                            <span className="slider round"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <CustomDropdown
                                        user={user}
                                        theme={theme}
                                        toggleTheme={toggleTheme}
                                        logout={logout}
                                    />
                                </div>
                            </div>
                            <div className={`overflow-bg d-none ${isMob ? 'active' : ''
                                }`}
                                onClick={() => onChangeBodyClass(!isMob)}
                            ></div>
                            <div className={`mobile-inner-header ${isMob ? 'active' : ''}`}
                                onClick={() => onChangeBodyClass(!isMob)}>
                                <div className={`mobile-inner-header-icon mobile-inner-header-icon-out ${isMob ? 'active' : ''
                                    }`}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default Header